import React from "react";
import Dialog from "../../../../../../components/base/dialog";
import {Col, Row} from "reactstrap";
import {Divider} from "@mui/material";
import Button from "../../../../../../components/base/button/button";
import {OutlinedInputForm} from "../../../../../../components/base/input/outlined_input";
import * as Yup from "yup";
import {makeRequired, makeValidate} from "mui-rff";
import Form from "../../../../../../components/base/form";
import ValidateMessages from "../../../../../../../core/models/static/texts/vallidate-messages";
import Api from "../../../../../../../core/services/api/api";
import useIsMounted from "../../../../../../hooks/use-is-mounted";

const schema = Yup.object().shape({
    description: Yup.string().nullable().required(ValidateMessages.required),
});

const subscription = {submitting: true, values: true, initialValues: true};

const ReportProblemModal = ({open, setOpen, partId}) => {
    const isMounted = useIsMounted();
    const validate = makeValidate(schema);
    const required = makeRequired(schema);

    /**
     * Calls api for reporting a problem for the provided part number
     * @param values
     */
    const reportProblem = (values) => {
        const forApi = {
            description: values.description,
            part: {
                id: partId,
            }
        }
        Api.reportPartProblem(forApi).then((response) => {
            if (!isMounted()) return;
            setOpen(false);
        })
    }

    return (
        <Dialog
            open={open}
            setOpen={setOpen}
        >
            <Row className='no-gutters align-items-center w-100'>
                <Row xs={12} className='no-gutters justify-content-center m-3 w-100'>
                    <p className='text-lg text-color-1 font-weight-semi-bold text-center'>Report Problem</p>
                </Row>
                <Divider className={'divider'}/>
                <div className='my-3 w-100'/>
                <Form
                    className='w-100'
                    onSubmit={reportProblem}
                    subscription={subscription}
                    validate={validate}
                    initialValues={{}}
                    render={({submitting, values, form}) => {
                        return (
                            <Row className='no-gutters justify-content-center w-100'>
                                <Col xs={12}
                                     className='mb-4 px-4'>
                                    <OutlinedInputForm
                                        minRows={10}
                                        multiline
                                        label={'Description'}

                                        name={'description'}
                                        type={'text'}
                                        required={required.description}
                                        value={values?.description ?? ''}
                                        onChange={(e) => form.change('description', e.target.value)}
                                    />
                                </Col>
                                <div className='my-1 w-100'/>
                                <Divider className={'divider'}/>
                                <Row className='no-gutters justify-content-between align-items-start w-100'>
                                    <Button
                                        disabled={!open || submitting}
                                        variant={'dialog'}
                                        color={'primary'}
                                        onClick={() => setOpen(false)}
                                        borderRadius={'0 8px 0 8px'}
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        disabled={!open || submitting}
                                        variant={'dialog'}
                                        color={'primary'}
                                        type={'submit'}
                                        borderRadius={'8px 0 8px 0'}
                                    >
                                        Report
                                    </Button>
                                </Row>
                            </Row>
                        );
                    }}
                />
            </Row>
        </Dialog>
    );
}

export default ReportProblemModal;
